export const TrimDocumentOnBlur = (opts = {}) => {
  const { onlyFrom } = opts;

  const onBlur = (e, change, editor) => {
    const { document: doc, startBlock } = change.value

    if (!doc) return;
    if (doc.nodes.size === 1) return;

    if (Array.isArray(onlyFrom)
        && startBlock
        && !onlyFrom.includes(startBlock.type)) {
      return;
    }

    const voidNodes = doc.nodes.filter(node => node.isVoid)
    if (voidNodes.size > 0) {
      // Because void block like an image may not have any text
      // but valid and visible to user.
      return;
    }

    const headline = doc.nodes.first()

    if (doc.text === headline.text) {
      // There are trailing blocks after headline but no content,
      // so trim them.
      doc.nodes
        .shift()
        .forEach(node => change.removeNodeByKey(node.key))

      // Don't return change, let Slate does its thing for onBlur.
      return;
    }
  }

  return { onBlur }
}



// WEBPACK FOOTER //
// ./src/components/slate/plugins/TrimDocumentOnBlur.js